/**
 * Governance — English Dictionary
 *
 * Domain/key structure compatible with future react-i18next migration.
 * Access: t.governance.controlTower.title
 * Future i18next: t('governance.controlTower.title') — no structural refactor needed.
 */
const en = {
  governance: {
    controlTower: {
      loading:        'Loading Control Tower data...',
      errorTitle:     'Error loading data',
      subtitle:       'Real-time operational view — NOW metrics + Quick actions + Active incidents',
      sectionNow:     'NOW — Today\'s Metrics',
      sectionWorker:  '⚙️ Worker & Pipeline',
      sectionActions: 'Quick Actions',
      sectionIncidents: '🚨 Top Incidents (Last 10)',
      viewAll:         'View all',
      noIncidents:     'No active incidents',
      noIncidentsDesc: 'System operating normally',
      footer:          'Data updated in real time (environment: production)',
      plannerTitle:    'Strategic Planner',
      plannerDesc:     'Create strategic plan with projected cost',
      builderTitle:    'Builder',
      builderDesc:     'Generate Copilot-ready tasks from the plan',
      agentsTitle:     'AI Agents',
      agentsSubtitle:  '14 active agents',
      agentsDesc:      'Enable/disable agents and monitor health',
      errorsLabel:     'errors',
      dateLocale:      'en-US',
    },

    onboarding: {
      title:         'Welcome to VUKZ',
      subtitle:      'Set up your account and activate your intelligence platform',
      step1Label:    'Organization',
      step2Label:    'Plan',
      step3Label:    'Users',
      step4Label:    'Ready',
      step1Title:    'Organization details',
      step1Desc:     'Confirm your company details to set up the account correctly.',
      step2Title:    'Your active plan',
      step2Desc:     'Review your contracted plan and included limits.',
      step3Title:    'Invite users',
      step3Desc:     'Add your team members and assign access roles.',
      step4Title:    'All set!',
      step4Desc:     'Your VUKZ account is configured. Access the governance dashboard.',
      orgNameLabel:    'Organization name',
      orgSectorLabel:  'Industry',
      orgCountryLabel: 'Country',
      planLabel:       'Current plan',
      planActiveUntil: 'Active until',
      addUserBtn:      'Add user',
      emailPlaceholder:'User e-mail',
      rolePlaceholder: 'Select role',
      nextBtn:         'Next',
      backBtn:         'Back',
      finishBtn:       'Go to dashboard',
      inviteBtn:       'Send invites',
      skipBtn:         'Skip for now',
      stepOf:          (current, total) => `Step ${current} of ${total}`,
      alreadyConfigured: 'Account already configured.',
      goToDashboard:   'Access governance',
      roleOptions: {
        gov_manager:   'Governance Manager',
        sports_manager:'Sports Manager',
        analyst:       'Analyst',
        viewer:        'Viewer',
        finance:       'Finance',
        hr:            'HR',
      },
      sectorOptions: {
        sports:      'Sports',
        corporate:   'Corporate',
        education:   'Education',
        health:      'Health',
        government:  'Government',
        other:       'Other',
      },
      inviteSent:    'Invites sent.',
      inviteError:   'Error sending invites.',
      saveOrgError:  'Error saving organization.',
    },

    users: {
      // Documentation keys for future migration (GovernanceUsersPage already translated inline)
      pageTitle:    'Users & Access',
      pageSubtitle: 'Manage users, roles, permissions and plans for the VUKZ platform.',
    },
  },
};

export default en;
